<template>
  <div
    class="flex flex-col md:flex-row justify-between gap-7 sm:gap-7 md:gap-7 lg:gap-12 w-full group"
  >
    <div
      v-for="(element, index) in elements"
      :key="element.id || index"
      class="box px-6 py-8 flex flex-col items-start rounded-xl shadow-md transition-all duration-1000 ease-in-out w-full md:w-1/3 min-w-[230px] flex-1"
      :class="
        hoverAnimation &&
        'group-hover:opacity-50 hover:!opacity-100  opacity-100  lg:hover:w-1/2 lg:hover:z-10 hover:flex-initial'
      "
    >
      <div
        class="flex-shrink-0"
        :class="element.imageStyle"
        v-if="element.imageSrc"
      >
        <img
          :src="element.imageSrc"
          :alt="element.imageAlt"
          class="w-full h-full object-contain rounded-lg"
        />
      </div>

      <h3 class="text-2xl font-semibold my-3">{{ element.title }}</h3>

      <h2 class="text-base text-gray-900 mb-3 hideText3lines min-h-[3lh]">
        {{ element.text }}
      </h2>

      <a
        :href="element.seeMoreUrl"
        class="link flex items-end gap-2 flex-1"
        v-if="element.seeMoreUrl"
      >
        <div>
          See more
          <font-awesome-icon :icon="['fas', 'arrow-right']" class="w-4 h-4" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true,
    },
    hoverAnimation: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.box {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}
</style>
